import { formatCommission } from "@platform/formatting-utils";

import type { Coverage, CoveragePlan } from "@platform/api";

const withPlanCommissionText = (plan: CoveragePlan): CoveragePlan => ({
  ...plan,
  currentCommission:
    formatCommission(plan.currentCommissionDetail) || plan.currentCommission,
  requestedCommission:
    formatCommission(plan.requestedCommissionDetail) ||
    plan.requestedCommission,
});

export const withCommissionText = (coverage: Coverage): Coverage => ({
  ...coverage,
  details: {
    ...coverage.details,
    plans: coverage.details.plans.map(withPlanCommissionText),
  },
});
